import { autoinject } from 'aurelia-framework';
import { PenDimensionPipeDto } from 'models/pen/PenDimensionPipe';
import { AuthHttpClient } from 'services/auth-http-client';
import { BaseApiService } from 'services/base-api-service';
import { PenSegmentWeldingLogDto } from 'views/pens/pen/production/pen-segment-welding-log-create-dialog';

@autoinject
export class PenDimensionPipeService extends BaseApiService<PenDimensionPipeDto> {
  constructor(httpClient: AuthHttpClient) {
    super(httpClient, PenDimensionPipeDto);
  }

  public async previewWeldingLog(penSegmentWeldingLogDto: PenSegmentWeldingLogDto) {
    const response = await this.httpClient.fetch(`${PenDimensionPipeDto.ApiUrl}/preview`, {
      method: 'POST',
      body: JSON.stringify(penSegmentWeldingLogDto),
    });
    const fileName = `Test`;
    return {
      blob: await response.blob(),
      fileName,
    };
  }
}
